import React, { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const BANNERS = [
  {
    id: "bestsellery",
    title: "Bestsellery tygodnia",
    subtitle: "Najchętniej kupowane ebooki i audiobooki — do -30%",
    cta: "Zobacz bestsellery",
    target: "bestsellery",
    img: "/img/hero/banner-1.jpg",
    accent: "from-amber-400 to-orange-500",
  },
  {
    id: "nowosci",
    title: "Nowości miesiąca",
    subtitle: "Świeże premiery wydawnicze prosto do Twojej biblioteki",
    cta: "Odkryj nowości",
    target: "katalog",
    img: "/img/hero/banner-2.jpg",
    accent: "from-cyan-400 to-blue-500",
  },
  {
    id: "audiobooki",
    title: "Słuchaj w drodze",
    subtitle: "Audiobooki z darmową próbką — sprawdź przed zakupem",
    cta: "Posłuchaj próbki",
    target: "audiobooki",
    img: "/img/hero/banner-3.jpg",
    accent: "from-teal-400 to-emerald-500",
  },
  {
    id: "aplikacje",
    title: "Kilkadziesiąt aplikacji AI w jednym miejscu",
    subtitle: "Prawo, finanse, auto, biuro, nauka języków, dzieci i gry — wirtualni asystenci do wszystkiego",
    cta: "Poznaj aplikacje",
    target: "aplikacje",
    img: "/img/hero/apps-banner-v2.jpg",
    accent: "from-fuchsia-400 to-cyan-500",
  },
];

export function BannerCarousel() {
  const [index, setIndex] = useState(0);
  const touchX = useRef(null);

  useEffect(() => {
    const t = setInterval(() => setIndex((i) => (i + 1) % BANNERS.length), 5000);
    return () => clearInterval(t);
  }, []);

  const go = (dir) => setIndex((i) => (i + dir + BANNERS.length) % BANNERS.length);

  const onTouchStart = (e) => { touchX.current = e.touches[0].clientX; };
  const onTouchEnd = (e) => {
    if (touchX.current == null) return;
    const dx = e.changedTouches[0].clientX - touchX.current;
    touchX.current = null;
    if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
  };

  return (
    <div className="relative overflow-hidden rounded-3xl" data-testid="banner-carousel" onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
      <div className="flex transition-transform duration-700 ease-[cubic-bezier(0.22,1,0.36,1)]" style={{ transform: `translateX(-${index * 100}%)` }}>
        {BANNERS.map((b) => (
          <div key={b.id} className="relative min-w-full">
            <div className="relative min-h-[16rem] sm:h-80">
              <img src={b.img} alt={b.title} className="absolute inset-0 h-full w-full object-cover" loading="lazy" decoding="async" />
              <div className="absolute inset-0 bg-gradient-to-r from-slate-950/90 via-slate-950/50 to-transparent" />
              <div className="relative flex min-h-[16rem] flex-col justify-center px-6 py-8 pb-12 sm:h-full sm:px-12">
                <span className={`w-fit rounded-full bg-gradient-to-r ${b.accent} px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-slate-950`}>
                  Promocja
                </span>
                <h3 className="mt-3 font-display text-2xl font-extrabold text-white sm:text-4xl">{b.title}</h3>
                <p className="mt-2 max-w-md text-sm text-slate-300 sm:text-base">{b.subtitle}</p>
                <button
                  data-testid={`banner-cta-${b.id}`}
                  onClick={() => document.getElementById(b.target)?.scrollIntoView({ behavior: "smooth" })}
                  className="mt-5 w-fit rounded-full bg-white px-6 py-2.5 text-sm font-bold text-slate-950 transition-transform hover:scale-105 active:scale-95"
                >
                  {b.cta}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <button onClick={() => go(-1)} aria-label="Poprzedni baner" className="absolute hidden sm:block left-3 top-1/2 -translate-y-1/2 rounded-full bg-slate-950/50 p-2 text-white backdrop-blur transition-colors hover:bg-slate-950/80">
        <ChevronLeft className="h-5 w-5" />
      </button>
      <button onClick={() => go(1)} aria-label="Następny baner" className="absolute hidden sm:block right-3 top-1/2 -translate-y-1/2 rounded-full bg-slate-950/50 p-2 text-white backdrop-blur transition-colors hover:bg-slate-950/80">
        <ChevronRight className="h-5 w-5" />
      </button>

      <div className="absolute bottom-4 left-1/2 flex -translate-x-1/2 gap-2">
        {BANNERS.map((b, i) => (
          <button
            key={b.id}
            data-testid={`banner-dot-${b.id}`}
            onClick={() => setIndex(i)}
            aria-label={`Baner ${i + 1}`}
            className={`h-1.5 rounded-full transition-all duration-300 ${i === index ? "w-8 bg-cyan-400" : "w-3 bg-white/40"}`}
          />
        ))}
      </div>
    </div>
  );
}
